const useAuth = () => {
  const user = { loggedIn: localStorage.getItem("jwt") };
  return user && user.loggedIn;
};

export default useAuth;
